<template>
  <!--弹框6 开始-->
  <el-dialog :visible.sync="frameLastDialog" top="35vh" :close-on-click-modal="showClo" :close-on-press-escape="showClo" :width="frameWidth" :show-close="showClo" center style="text-align: center;">
    <div style="width:100%;text-align: center;">
      <div><img src="https://res.roompai.com/static/img/frame/last.png" class="frame-small-img revolve"></div>
      <div class="frame-text-rise">
        <div class="wordBreak">{{$t('onlyStepLeft')}}!</div>
        <div class="textRed wordBreak">{{$t('roomOnly')}} {{homeSurplus}} {{$t('roomLeft')}}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="dialog-gohome" @click="frameLastDialogFun">{{$t('continueBooking')}}</el-button>
      </span>
    </div>
  </el-dialog>
  <!--弹框6 结束-->
  <!--引入方式-->
  <!-- <frameLast :frameLastDialog="frameLastDialog" :homeSurplus="homeSurplus"></frameLast> -->
</template>

<script>
export default {
  name: 'frameQuotation',
  props: ['frameLastDialog', 'homeSurplus'],
  data () {
    return {
      frameWidth: '450px',
      showClo: false
    }
  },
  mounted () {
    if (document.body.clientWidth < 1001) {
      this.frameWidth = '95%'
    } else {
      this.frameWidth = '450px'
    }
  },
  methods: {
    frameLastDialogFun: function () {
      var submitInfo = {'click': 1}
      this.$emit('frameLastDialogFun', submitInfo)
    }
  }
}
</script>

<style scoped>
.frame-small-img{width:80px; height:80px;cursor: pointer;}
.revolve{-webkit-transform: rotateY(180deg);transform: rotateY(180deg);}
.frame-text-rise{height:50px; line-height: 22px;font-size: 16px;color: #4F4C4C;text-align: center; margin-top: 10px;}
.dialog-gohome{width: 30%;background-color: #333;border: 1px solid #333;border-radius: 4px;font-weight: 500;font-size: 14px;color: #FFFFFF;}
.dialog-gohome:hover{background-color: rgb(252, 210, 5, 1); color:#4F4C4C;border-color: rgb(252, 210, 5, 1); }
@media screen and (max-width: 1000px) {
.dialog-gohome{width:100%; margin-bottom: 10px;}
}
</style>



// WEBPACK FOOTER //
// src/components/public/frameLast.vue